
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { logger } from "@/services/logger";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    logger.error(
      `404 Error: User attempted to access non-existent route: ${location.pathname}`,
      {
        metadata: { path: location.pathname }
      }
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <SEO 
        title="Seite nicht gefunden"
        description="Die gesuchte Seite wurde nicht gefunden."
        noindex={true}
        canonicalPath="/404"
      />
      
      <div className="text-center max-w-md px-4">
        <h1 className="text-6xl font-bold text-meetme-600 mb-4">404</h1>
        <p className="text-2xl text-gray-800 mb-6">Die Seite wurde nicht gefunden</p>
        <p className="text-gray-600 mb-8">
          Die gewünschte Seite existiert nicht oder ist unter einer anderen URL verfügbar.
        </p>
        <Link to="/">
          <Button className="bg-meetme-600 hover:bg-meetme-700">
            Zurück zur Startseite
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
